<div
  class="cc-finance-modal-wrapper"
  [@showHideWidget]="displayWidget$ | async"
  (@showHideWidget.done)="onAnimationDone($event)"
>
  <ccwb-modal
    class="cc-finance-modal"
    #modalRef
    (wbclose)="onClose()"
    size="l"
    variant="info"
    close-on-backdrop-click
    close-on-escape-key
    tabindex="0"
  >
    <ccwb-modal-level>
      <cc-finance-calculator [isWidgetVisible]="displayWidgetContent" />
    </ccwb-modal-level>
  </ccwb-modal>
</div>
